import { render } from "./ThemesSkeleton.vue?vue&type=template&id=fdbe9bea&scoped=true"
const script = {}

import "./ThemesSkeleton.vue?vue&type=style&index=0&id=fdbe9bea&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbe9bea"]])

export default __exports__